
import { Injectable } from '@angular/core';
import {  DeviceCommunicationService } from '@ubie/client-core';
import { LogService, SipDevicesService,MqttService, OfflinecommunicationService, CachingService } from '@ubie/core';
import { SipHelper } from './sipHelper';

import {
    Plugins
} from '@capacitor/core';

const { UbieSipConfiguration } = Plugins;

@Injectable()
export class LoginHelper {

    constructor(
        private mqttService: MqttService,
        private deviceComm: DeviceCommunicationService,
        private sipHelper: SipHelper,
        private logger: LogService,
        private offlineService: OfflinecommunicationService,
        private cacheService: CachingService
    ) { }


    /////////////////////////////////////////////////////////
    //#region SIP PROPERTIES
    /////////////////////////////////////////////////////////

    currentDeviceUid: string;
    storageKey = 'sipDeviceUid';

    //#endregion
    /////////////////////////////////////////////////////////



 init() {
    this.logger.debug("LOGIN_HELPER - init called");
    this.initMqttCommunication();
     this.sipHelper.initSip();
     
    }

   async end() {
        this.logger.info("end called");
        this.endMqttCommunication(true);
        this.sipHelper.stopSipOnDevice();
        this.cacheService.clearCache();
        await this.offlineService.clearData();
        
   
    }


    //#region MQTT

    /**
     * Init mqtt communication
     */
    private initMqttCommunication() {

        this.logger.debug('LOGIN_HELPER - init mqtt ');


        // start mqtt communication
        this.mqttService.connect().then(
            (x) => {
             
                this.logger.debug('LOGIN_HELPER - mqtt connect call finished ' );
               

            }).catch(
                (error) => this.logger.error('LOGIN_HELPER - connection status error: ' + error));

    }

    private endMqttCommunication(stop: boolean) {
        // stop mqtt communication
        if(!this.mqttService.mqttConnection) {
            return;
        }

        this.deviceComm.unsubscribeAll();

    
        
        
    }
    //#endregion



}
